export const FLOW_FETCH_FORM_PERMISSIONS = 'FLOW_FETCH_FORM_PERMISSIONS';
export const FLOW_FETCH_FORM_PERMISSIONS_START = `${FLOW_FETCH_FORM_PERMISSIONS}_START`;
export const FLOW_FETCH_FORM_PERMISSIONS_SUCCESS = `${FLOW_FETCH_FORM_PERMISSIONS}_SUCCESS`;
export const FLOW_FETCH_FORM_PERMISSIONS_FAIL = `${FLOW_FETCH_FORM_PERMISSIONS}_FAIL`;
export const FLOW_UPDATE_FORM_PERMISSIONS = 'FLOW_UPDATE_FORM_PERMISSIONS';

/**
Fetches the permissions of the corresponding 'formId' and 'planId'
 */
export function fetchFormPermissions(formId, planId) {
  return dispatch => {
    return dispatch({
      type: FLOW_FETCH_FORM_PERMISSIONS,
      meta: {
        xmApi: true,
        uri: `/api/xm/1/plans/${planId}/forms/${formId}/sender-permissions`,
        method: 'get',
      },
    });
  };
}

/**
  Updates the permissions of the corresponding 'formId' and 'planId'
   * Example of 'data': 
     [{ id: 'e60eb755-c8c6-6fea-2d01-ed0af5df7cf7',
        displayName: 'Developer',
        senderType: 'ROLE',
        sender: {
          id: 'e60eb755-c8c6-6fea-2d01-ed0af5df7cf7',
          name: 'Developer'
        }
      },...]
   */
export function updatePermissions(formId, planId, data) {
  return dispatch => {
    return dispatch({
      type: 'sendPermissions',
      meta: {
        xmApi: true,
        uri: `/api/xm/1/plans/${planId}/forms/${formId}/sender-permissions`,
        method: 'put',
        params: data,
      },
    });
  };
}

export function updateFormPermissionsInStore(permissions) {
  return {
    type: FLOW_UPDATE_FORM_PERMISSIONS,
    payload: permissions,
  };
}
